import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'join',
})
export class JoinPipe implements PipeTransform {
  transform(value?: string[] | null, seperator = ', ', alternative = '-'): string | undefined | null {
    if (value === undefined || value === null) {
      return value
    }
    return value.length === 0 ? alternative : value.join(seperator)
  }
}
